import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css' // optional
import VueGoodTablePlugin from 'vue-good-table-next'
import 'vue-good-table-next/dist/vue-good-table-next.css'
import windowSizePlugin from './plugins/windowSize'
import devicePlugin from './plugins/device'
import authPlugin from './plugins/authPlugin'
import './registerServiceWorker'
import 'chartjs-adapter-date-fns'

const app = createApp(App)
app.use(router)
app.use(VueGoodTablePlugin)
app.use(windowSizePlugin)
app.use(devicePlugin)
app.use(authPlugin)
app.mount('#app')

// Prevent pinch zoom
document.addEventListener(
  'touchstart',
  function (e) {
    if (e.touches.length > 1) {
      e.preventDefault(); // Block pinch zoom
    }
  },
  { passive: false }
);

// Prevent double-tap zoom
let lastTouchEnd = 0;
document.addEventListener(
  'touchend',
  function (e) {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault(); // Block double-tap zoom
    }
    lastTouchEnd = now;
  },
  false
);

// Add global beforeunload listener
window.addEventListener('beforeunload', (event) => {
  // If we're refreshing after login, skip verification
  if (sessionStorage.getItem('skipBeforeUnload') === 'true') {
    sessionStorage.removeItem('skipBeforeUnload') // clear it so it’s only one-time
    return
  }

  // Otherwise, show confirmation
  event.preventDefault()
  event.returnValue = ''  // Required for most browsers
})


// Update fetch to include Authorization header
const originalFetch = window.fetch

window.fetch = async (input, init = {}) => {
  const token = localStorage.getItem('session_token')

  // Ensure headers exist
  const headers = new Headers(init.headers || {})

  // Always add Authorization header
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  } else {
    console.warn('Fetch called without session_token; request may be anonymous', input)
  }

  // Call the original fetch
  return originalFetch(input, { ...init, headers })
}
